import { ErrorImage } from '../ErrorImage'

export function ErrorTooManySessionsImage() {
  return <ErrorImage src="/images/too-many-sessions-error.png" alt="Error-Too-Many-Sessions" />
}
